import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import FormatDate from '../../../../../date/FormatDate';
import { Typography } from '@mui/material';


const AssessmentMarkingInfo = ({ users = [] }) => {
  const generatedColumns =
    users && users?.length > 0 ? users[0]?.questions?.map((question) => question?.title) : [];
  return (
    <div className='flex flex-wrap gap-4 pb-2 items-stretch justify-center overflow-auto'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className='text-xs'>#</TableCell>
              <TableCell className='text-xs'>Code</TableCell>
              <TableCell className='text-xs'>Name</TableCell>
              {generatedColumns?.length > 0 &&
                generatedColumns.map((column) => <TableCell className='text-xs'>{column}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.length > 0 ? (
              users?.map((user, index) => {
                return (
                  <TableRow key={`table-columd-body-${user?._id}-${index}`}>
                    <TableCell width={20} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell width={100} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {user?.code}
                      </Typography>
                    </TableCell>
                    <TableCell width={200} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {user?.name}
                      </Typography>
                    </TableCell>
                    {generatedColumns?.length > 0 &&
                      generatedColumns.map((column, colIndex) => {
                        const isTime = user?.questions[colIndex]?.type?.value === 'time';
                        const isDate = user?.questions[colIndex]?.type?.value === 'date';
                        const answers = user?.questions[colIndex]?.answer ?? [];

                        return (
                          <TableCell width={200} className='overflow-hidden'>
                            <Typography variant='body2' component={'span'}>
                              {isTime ? (
                                <FormatDate date={answers?.join(', ')} pattern='dd/MMM/yyyy HH:mm a' />
                              ) : isDate ? (
                                <FormatDate date={answers?.join(', ')} pattern='dd/MMM/yyyy' />
                              ) : (
                                answers
                                  ?.map((anw) => {
                                    return anw;
                                  })
                                  .join(', ')
                              )}
                            </Typography>
                          </TableCell>
                        );
                      })}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography
                    color='inherit'
                    component={'p'}
                    className='text-muted-foreground opacity-50 py-2 text-center'
                  >
                    You don't have any questions yet
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AssessmentMarkingInfo;
